import React from 'react';
import './_headerbar.css';
import { MdClose } from 'react-icons/lib/md';
import { isEmpty } from 'lodash/fp';
import { getCurrentContact } from '../../redux/contatoStore';
import { getUser } from '../../redux/loginStore';
import { menuActions } from '../../redux';
import { connect } from 'react-redux';
import ItemDropDown from '../itemdropdown/ItemDropDown';
import { isNotNil } from '../../utils';
import { RedButton, GreenButton } from '../Button';
import IconImage from '../IconImage';
import Avatar from '../Avatar';
import Info from '../Info'
import styled from 'styled-components';
import rightIcon from '../../img/icons/right.svg';
import closeIcon from '../../img/icons/close.svg';
import {hasDepartmentConfig} from "../../functions/config";

const avatar = require('../../img/icons/avatar.png');
const iconDeps = require('../../img/icons/share.png');

const ShowPerfil = styled.a`
    text-align: left;
    margin-top: 2px;
    text-decoration: none;
    font-size: 14px;
    color: #8a8a8a;
    font-family: Roboto-Lightc;

    :hover {
        text-decoration: underline;
    }
`;

const HeaderBar = ({ initChat, shouldInit, ...props }) => {

    const clickOptionsMenu = (key, option) => {
        const {
            id_pessoa_pes: contactId
      } = props.contato;

        if (!window.confirm("Alterar departamento?")) return false;
        props.changeDepartment(key, option.id, option.label, contactId)
    }

    const getOptionsMenu = () => {
        const { user: { configuracoes } } = props;


        if(!configuracoes || !configuracoes.departamentos){
            return null;
        }

        return configuracoes.departamentos.map(dep => ({
            label: dep.st_nome_grpu,
            id: dep.id_grupo_grpu
        }));
    }

    const renderUser = () => {
        const { contato = {} } = props
        let arrayUserType = [];

        if (contato && contato.fl_proprietariobeneficiario_pes == 1) arrayUserType.push("Proprietario");
        if (contato && contato.fl_locatario_pes == 1) arrayUserType.push("Locatario");
        if (contato && contato.fl_fiador_pes == 1) arrayUserType.push("Fiador");

        return !isEmpty(contato) && (
            <div style={{display: 'flex'}}
                title="Ver perfil"
                className="header-user-info"
                onClick={props.openMenu}>
                <Avatar
                    src={contato.st_fotourl_pes ? contato.st_fotourl_pes : avatar}
                    style={{ marginRight: 10 }} size={40}
                    alt="Imagem do Usuário"
                />
                <div>
                    <Info
                        title={contato.st_nome_pes}
                        subtitle={arrayUserType.join(' - ')}
                        subtitleStyle={{fontSize: 14, fontFamily: 'Roboto-Lightc'}}
                    />
                    <ShowPerfil onClick={props.openMenu}>Ver Perfil</ShowPerfil>
                </div>
            </div>
        )
    }

    const _onClickClose = () => {
        props.closeMenu();
    }
    const _onClickFinish = () => {

        props.onFinishChat(props.currentChat.id, props.contato.id_pessoa_pes);
    }

    const renderCloseButton = () => {
        const { contato, menu } = props;
        if ( contato && menu.menuOpen)
            return (
                <div id="header-toggle" >
                    <a href="#"
                        title="Fechar"
                        style={{ color: '#000' }}
                        onClick={() => _onClickClose()}>
                        <MdClose color="#8a8a8a"/>
                    </a>
                </div>
            )
        return null;
    }

    const renderDepartment = () => {

        let { user: { configuracoes }, contato, conversation } = props;
        const { departmentName, key } = conversation;

        if(!contato || !hasDepartmentConfig(configuracoes)){
            return null;
        }

        return (
            <ItemDropDown
                hint="Você pode alterar o departamento dessa conversa"
                label={departmentName || "Departamento"}
                image={iconDeps}
                options={getOptionsMenu()}
                onClickOption={option => {
                    clickOptionsMenu(key, option);
                    _onClickClose();
                }}
            />
        )
    }

    const renderFinishButton = () => {
        if (!props.currentChat) return null;

        return (
            <RedButton
                onClick={() => {
                    _onClickFinish();
                    _onClickClose();
                }} >
                <IconImage src={closeIcon} style={{ marginRight: 5 }}/>
                Finalizar
            </RedButton>
        )
    }

    const renderButtons = () => {
        const {
            currentChat,
            contato,
            user: { ids_departamentos, id }
        } = props;


        const hasCurrentChat = isNotNil(currentChat);

        const hasDepartment = !!(hasCurrentChat && (ids_departamentos.includes(currentChat.departmentId) || !currentChat.departmentId));

        const cannotInitChat = !!(hasCurrentChat && !hasDepartment && currentChat.attendentId && currentChat.attendentId != id);

        if (cannotInitChat) return null; 

        if (shouldInit) {
            return (
                <GreenButton
                    onClick={() => initChat(contato)}>
                    <IconImage src={rightIcon} style={{ marginRight: 5 }}/>
                    Iniciar Conversa
                </GreenButton>
            )
        }
        return (
            <React.Fragment>
                {renderDepartment()}
                {renderFinishButton()}
            </React.Fragment>
        );
    }

    return (
        <nav id="header-bar">
            <div id="header-conteudo">
                <div className="header-info-left">
                    <div className="header-info-left-user">
                        {renderUser()}
                    </div>
                </div>
                <div className="header-info-right">
                    {renderButtons()}
                </div>
            </div>
            {renderCloseButton()}
        </nav>
    )
}

const mapStateToProps = (state) => {
    return {
        contato: getCurrentContact(state),
        menu: state.menu,
        user: getUser(state)
    }
}
export default connect(mapStateToProps, menuActions)(HeaderBar);



// WEBPACK FOOTER //
// ./src/components/headerbar/HeaderBar.js